<template>
    <div v-if="cliente">
        <Box  @close="cerrar(false)" :width="'800px'">
            <template #top>Modificar Cliente</template>
            <template #center>
                <div class="nj-cols">
                    <div class="nj-card">
                        <div class="nj-cols form">
                            <div class="nj-cols form c2">
                                <div>
                                    <div class="nj-label">Tipo de documento</div>
                                    <select class="nj-select" v-model="cliente.cli_tipo_documento_identidad">
                                        <option :value="item.id" v-for="item in lista_tipo_documento_identidad" :key="item.id">{{ item.nombre }}</option>
                                    </select>
                                </div>
                                <div>
                                    <div class="nj-label">Documento</div>
                                    <input type="text" class="nj-text" v-model="cliente.cli_documento_identidad">
                                </div>
                            </div>
                            <div>
                                <div class="nj-label">Nombres y apellidos / Razón Social</div>
                                <input type="text" class="nj-text" v-model="cliente.cli_nombre">
                            </div>
                            <div>
                                <div class="nj-label">Domicilio Fiscal</div>
                                <input type="text" class="nj-text" v-model="cliente.cli_domicilio_fiscal">
                            </div>
                            <div class="nj-cols form c2">
                                <div>
                                    <div class="nj-label">Correo</div>
                                    <input type="text" class="nj-text" v-model="cliente.cli_correo">
                                </div>
                                <div>
                                    <div class="nj-label">Teléfono / Celular</div>
                                    <input type="text" class="nj-text" v-model="cliente.cli_telefono">
                                </div>
                            </div>
                            <div>
                                <div class="nj-label">Nombres y apellidos del contacto</div>
                                <input type="text" class="nj-text" v-model="cliente.cli_nombre_contacto">
                            </div>
                        </div>
                    </div>
                    <!-- <div class="nj-card">
                        <div class="nj-subtitle-1">Direcciones de Envío</div>
                        <div class="nj-cols form c2">
                            <div>
                                <div class="nj-label">Dirección</div>
                                <input type="text" class="nj-text" v-model="cliente_direccion_envio.cde_direccion">
                            </div>
                            <div>
                                <div class="nj-label">Referencia</div>
                                <input type="text" class="nj-text" v-model="cliente_direccion_envio.cde_referencia">
                            </div>
                            <div>
                                <div class="nj-label">Distrito</div>
                                <select class="nj-select" v-model="cliente_direccion_envio.ubi_id">
                                    <option></option>
                                    <option v-for="item in distritos" :key="item.ubi_id" :value="item.ubi_id">{{ item.ubi_nombre }}</option>
                                </select>
                            </div>
                            <div>
                                <div class="nj-label">Alias / Proyecto</div>
                                <input type="text" class="nj-text" v-model="cliente_direccion_envio.cde_alias">
                            </div>
                        </div>
                        <Buttons line>
                            <button class="nj-button c-green" @click="agregarDireccion()"><i class="mdi-plus"></i>Agregar</button>
                        </Buttons>
                        <br>
                        <b-table :data="cliente.lista_cliente_direccion_envio">
                            <template slot-scope=" props">
                                <b-table-column label="Dirección" header-class="is-info">{{ props.row.cde_direccion }}</b-table-column>
                                <b-table-column label="Referencia" header-class="is-info">{{ props.row.cde_referencia }}</b-table-column>
                                <b-table-column label="Distrito" header-class="is-info">{{ getDistrito(props.row.ubi_id) }}</b-table-column>
                                <b-table-column label="Alias" header-class="is-info">{{ props.row.cde_alias }}</b-table-column>
                                <b-table-column label="Opciones" header-class="is-info">
                                    <div class="nj-flx">
                                        <button class="nj-button icon c-red" @click="removerDireccion(props.row.cde_sequence)" title="Remover"><i class="mdi-delete"></i></button>
                                    </div>
                                </b-table-column>
                            </template>
</b-table>
</div> -->
                </div>
            </template>
            <template #bottom>
                <button class="nj-button c-green" @click="modificar()"><i class=" mdi-content-save"></i>Modificar</button>
            </template>
        </Box>
    </div>
</template>

<script>
import Toast from "../../util/toast"
import { Buttons, Box } from "../components"
import { AppService, ClienteService, ResponseStatus } from "../../rest"

export default {
    name: "ModificarCliente",
    components: {
        Box,
        Buttons
    },
    data() {
        return {
            cliente: null,
            sequence: 1,
            cliente_direccion_envio: {
                ubi_id: null,
                cde_referencia: null,
                ubi_id: null,
                cde_alias: null,
            },
            distritos: [],
        }
    },
    props: {
        cli_id: {
            type: Number
        },
        lista_tipo_documento_identidad: {
            type: Array
        },
    },
    methods: {
        modificar() {
            let errors = 0
            if (this.cliente.cli_tipo_documento_identidad == null) errors++
            if (this.cliente.cli_documento_identidad == null) errors++
            if (this.cliente.cli_nombre == null) errors++
            if (this.cliente.cli_nombre_contacto == null) errors++
            if (this.cliente.cli_domicilio_fiscal == null) errors++
            if (this.cliente.cli_correo == null) errors++
            if (this.cliente.cli_telefono == null) errors++
            if (this.cliente.lista_cliente_direccion_envio.length == 0) errors++
            if (errors == 0) {
                ClienteService.modificar({
                    cliente: this.cliente
                }).then(
                    response => {
                        if (ResponseStatus.isSuccess(response)) {
                            Toast.success(response.message)
                            this.cerrar(true)
                        }
                        else {
                            Toast.warn(response.message)
                        }
                    },
                    error => {
                        Toast.error(error)
                        console.error(`error: `, error)
                    }
                )
            }
            else {
                Toast.warn("Falta ingresar datos para modificar al cliente")
            }
        },
        agregarDireccion() {
            let errors = 0
            if (!this.cliente_direccion_envio.cde_direccion) errors++
            if (!this.cliente_direccion_envio.cde_referencia) errors++
            if (!this.cliente_direccion_envio.ubi_id) errors++
            if (!this.cliente_direccion_envio.cde_alias) errors++
            if (errors == 0) {
                this.sequence++
                this.cliente.lista_cliente_direccion_envio.push({
                    cde_sequence: this.sequence,
                    cde_direccion: this.cliente_direccion_envio.cde_direccion,
                    cde_referencia: this.cliente_direccion_envio.cde_referencia,
                    ubi_id: this.cliente_direccion_envio.ubi_id,
                    cde_alias: this.cliente_direccion_envio.cde_alias,
                })
                this.cliente_direccion_envio.cde_direccion = null
                this.cliente_direccion_envio.cde_referencia = null
                this.cliente_direccion_envio.ubi_id = null
                this.cliente_direccion_envio.cde_alias = null
            }
            else {
                Toast.warn("Falta ingresar datos para agregar la dirección de envio")
            }
        },
        removerDireccion(sequence) {
            this.cliente.lista_cliente_direccion_envio = this.cliente.lista_cliente_direccion_envio.filter(item => item.cde_sequence != sequence)
        },
        getDistrito(id) {
            return this.distritos.find((item) => item.ubi_id == id).ubi_nombre
        },
        cerrar(condition) {
            this.$emit("close", { componente: "modificar", abrir: false, buscar: condition })
        }
    },
    mounted() {
        // obteniendo los distritos
        AppService.getData(["distritos"]).then(
            response => {
                if (ResponseStatus.isSuccess(response)) {
                    this.distritos = response.data.distritos
                    // obteniendo datos del cliente
                    ClienteService.obtener({
                        cliente: {
                            cli_id: this.cli_id
                        }
                    }).then(
                        response => {
                            if (ResponseStatus.isSuccess(response)) {
                                this.cliente = response.data
                                this.cliente.lista_cliente_direccion_envio.forEach(item => {
                                    item.cde_sequence = this.sequence
                                    this.sequence++
                                })
                            }
                            else {
                                Toast.warn(response.message)
                            }
                        },
                        error => {
                            Toast.error(error)
                            console.error(`error: `, error)
                        }
                    )
                }
                else {
                    Toast.warn(response.message)
                }
            },
            error => {
                Toast.error(error)
                console.error(`error: `, error)
            }
        )

    }
}
</script>

<style scoped></style>